import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-789a375f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base-editor"
}
const _hoisted_2 = {
  key: 1,
  class: "disabledTxt"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }


import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, onMounted, computed, ref, shallowRef, watch } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { IDomEditor, Boot, i18nChangeLanguage, IToolbarConfig } from '@wangeditor/editor'
import mentionModule, { MentionElement } from '@wangeditor/plugin-mention'
import { Form } from 'ant-design-vue'
import xss from 'xss'
import { useI18n } from 'vue-i18n'
import { useInteractionStore } from '@/stores/interaction'
const __default__ = { name: 'Editor' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: String,
    default: ''
  },
  mode: {
    type: String,
    default: 'default'
  },
  mention: {
    type: Array
  },
  maxlength: {
    type: Number
  },
  action: {
    type: String,
    default: '/api/admin/v1/storage/shareUpload'
  },
  placeholder: String,
  disabled: Boolean
},
  emits: ['update:value', 'update:mention'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
Boot.registerModule(mentionModule)
const editorRef = shallowRef()
// 内容 HTML
const dutyBy = ref('')
const userSelectRef = ref()
const flexXY = ref({
  top: 100,
  left: 2
})
const valueHtml = ref('')
const prevHtml = ref('')
const autofocus = ref(false)
const props = __props
const shareInfo = useInteractionStore()
const emit = __emit
const formItemContext = Form.useInjectFormItemContext()
const placeholderComputed = computed(() => {
  if (props.placeholder) {
    return props.placeholder
  }
  return `1. ${t('follow.process')}<br />2. ${t('follow.result')}<br />3. ${t('follow.follow-up')}<br />4. ${t(
    'follow.problemsAndHelp'
  )}`
})
// 富文本空值票判断
const checkVal = (str: string) => {
  let num = 0
  const reg = /<p>(&nbsp;|&nbsp;\s+)+<\/p>|<p>(<br>)+<\/p>/g
  while (num < str.length && str !== '') {
    num++
    const k = str.match(reg)
    if (k) {
      str = str.replace(k[0], '')
    }
  }
  return str === ''
}
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== valueHtml.value) {
      valueHtml.value = xss(v)
    } else if (!v && editorRef.value) {
      editorRef.value.clear()
      emit('update:mention', [])
    }
  }
)

const toolbarConfig: Partial<IToolbarConfig> = {
  toolbarKeys: ['emotion']
}
const hideModal = () => {
  autofocus.value = false
}
// 显示弹框
const showModal = (editor: IDomEditor) => {
  // 获取光标位置，定位 modal
  const domSelection: any = document.getSelection()
  const domRange = domSelection.getRangeAt(0)
  if (domRange == null) return
  const selectionRect = domRange.getBoundingClientRect()
  flexXY.value = {
    left: selectionRect.left,
    top: selectionRect.top
  }
  dutyBy.value = ''
  // editorRef.value.blur()
  setTimeout(() => {
    autofocus.value = true
  }, 100)
  setTimeout(() => {
    userSelectRef.value?.focus()
  }, 300)

  // 显示 modal 弹框，并定位
  // PS：modal 需要自定义，如 <div> 或 Vue React 组件
}
// 当触发某事件（如点击一个按钮）时，插入 mention 节点
function insertMention(v: any, option: any) {
  const user = userSelectRef.value.getValueObj(v)
  if (!user) {
    return
  }
  const mentionNode: MentionElement = {
    type: 'mention', // 必须是 'mention'
    value: `${user.userName}(${user.employeeNo})`, // 文本
    info: 'mentionByemployeeNo' + user.employeeNo + 'mentionByemployeeNo', // 其他信息，自定义
    children: [{ text: '' }] // 必须有一个空 text 作为 children
  }
  editorRef.value.restoreSelection() // 恢复选区
  editorRef.value.deleteBackward('character') // 删除 '@'
  editorRef.value.insertNode(mentionNode) // 插入 mention
  editorRef.value.move(1) // 移动光标
}
const editorConfig = {
  // placeholder: placeholder.value,
  autoFocus: false,
  EXTEND_CONF: {
    mentionConfig: {
      showModal, // 必须
      hideModal // 必须
    }
  }
}
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})
const handleCreated = (editor: IDomEditor) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}
const setMention = () => {
  // 处理@
  let userCodes: any = []
  // const myreg = /(?<=mentionByemployeeNo).*?(?=mentionByemployeeNo)/g
  const myreg = /mentionByemployeeNo(.*?)mentionByemployeeNo/g
  userCodes = valueHtml.value.match(myreg)
  if (!userCodes) {
    userCodes = []
  }
  const mention: any = []
  userCodes.forEach((item: any) => {
    mention.push(item.replaceAll('mentionByemployeeNo', ''))
  })
  emit('update:mention', mention)
}
const handleChange = (editor: IDomEditor) => {
  if (valueHtml.value === props.value) {
    return
  }
  if (props.maxlength && editor.getText().length > props.maxlength && !prevHtml.value) {
    prevHtml.value = valueHtml.value
    return
  }
  let result = valueHtml.value
  if (checkVal(valueHtml.value)) {
    result = ''
  }
  emit('update:value', result)
  setMention()
  formItemContext.onFieldChange()
}
const handleBlur = (editor: IDomEditor) => {
  if (props.maxlength && valueHtml.value.length > props.maxlength) {
    editor.setHtml(prevHtml.value)
  }
}
onMounted(() => {
  if (shareInfo.language === 'en-US') {
    i18nChangeLanguage('en')
  } else {
    i18nChangeLanguage('zh-CN')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Toolbar), {
            style: {"border-bottom":"1px solid #d8dfe4"},
            editor: editorRef.value,
            defaultConfig: toolbarConfig,
            mode: __props.mode
          }, null, 8, ["editor", "mode"]),
          _createVNode(_unref(Editor), {
            style: {"height":"200px","overflow-y":"hidden"},
            modelValue: valueHtml.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueHtml).value = $event)),
            defaultConfig: {
        placeholder: placeholderComputed.value,
        ...editorConfig
      },
            mode: __props.mode,
            onOnCreated: handleCreated,
            onOnChange: handleChange,
            onOnBlur: handleBlur
          }, null, 8, ["modelValue", "defaultConfig", "mode"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", { innerHTML: valueHtml.value }, null, 8, _hoisted_3)
        ])),
    _createElementVNode("div", {
      style: _normalizeStyle({ width: '200px', position: 'fixed', top: flexXY.value.top + 'px', left: flexXY.value.left + 'px' }),
      class: "UserSelect"
    }, [
      (autofocus.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_UserSelect, {
              value: dutyBy.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dutyBy).value = $event)),
              placeholder: _ctx.$t('common.pleaseSelect'),
              allowClear: "",
              open: true,
              ref_key: "userSelectRef",
              ref: userSelectRef,
              onSelect: insertMention
            }, null, 8, ["value", "placeholder"])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 64))
}
}

})